import * as yup from 'yup';

export const REGISTER_FORM_VALIDATIONS = yup.object().shape({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  email: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address'),
  phone: yup.string().required('Phone number is required'),
});

export const UPDATE_FORM_VALIDATIONS = yup.object().shape({
  first_name: yup.string().required('First name is required'),
  last_name: yup.string().required('Last name is required'),
  email: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address'),
  phone: yup.string().required('Phone number is required'),
});
